
import {TaskError} from 'utils/errors'
import Tasks from 'utils/tasks'

export default {
  props: {
    parent: {type: Node, default: document.body},
    apiUrl: {type: String, required: true},
    apiArgs: {type: Function, required: true},
    expectedHeight: {type: Number, default: undefined, required: false},
    can_genrate: {type: Boolean, required: true},
    content_margin: {type: String, default: '1.4rem', required: false}
  },
  emits: ['generated'],
  data() {
    return {
      tasks: new Tasks(),
      visible: false,
      bottom: false,
      task_id: undefined,
      task_error: undefined,
      task_result: undefined,
      options: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [75, 15]
            }
          },
        ],
      }
    }
  },
  computed: {
    loading() {
      return this.task_error || this.task_result ? false : true
    },
    api_args() {
      return this.apiArgs ? this.apiArgs() : undefined
    },
    z_index() {
      return this.visible ? 12 : 0
    },
    errmsg() {
      if (this.task_error.code === 1000) {
        return 'Not enough information to generate AI content.<br>Fill fields above and try again.'
      }
      return 'Failed to generate AI content.<br>Please try again.'
    },
    disabled(){
      return !this.api_args || !this.can_genrate
    }
  },
  methods: {
    show(){
      if (this.visible) { 
        return
      }

      if (!this.task_id || this.task_error) {
        this.generate()
      }
           
      this.visible = true
    },
    onClickOutside(ev){
      if (ev && this.$refs.pp?.popperRef?.contentRef?.contains(ev.target)) {
        return
      }
      this.hide()
    },
    hide(){
      this.visible = false
    },
    async generate() {
      this.task_id = undefined
      this.task_error = undefined
      this.task_result = undefined
      try {
        this.task_id = await this.tasks.start(this.apiUrl, this.api_args)
        this.task_result = await this.tasks.waitResult(this.task_id)
        this.$emit('generated', this.task_result)
      }
      catch (err) {
        this.task_error = err instanceof TaskError ? err.task_error : err
      }
      finally {
        // it is necessary to redraw the popup (so that the arrow does not move when adding content).
        this.$nextTick(() => dispatchEvent(new CustomEvent('scroll')))
      }
    }
  }
}
